export default "__VITE_ASSET__C6HCvR4T__"